import 'intersection-observer'
import { addClass } from './dom'

export const lazyLoadImages = (threshold = [0.01]) => {
  const observer = new IntersectionObserver(changes => {
    changes.forEach(({ target, intersectionRatio }) => {
      if (intersectionRatio > 0) {
        const { src } = target.dataset

        observer.unobserve(target)
        target.setAttribute('src', src)
        target.removeAttribute('data-src')
        target.onload = () => {
          addClass(target.parentNode, 'is-loaded')
        }
      }
    })
  }, { threshold })

  Array.from(document.querySelectorAll('.lazy-load[data-src]')).forEach(el => observer.observe(el))
}
